import CheckmateApiClient from '../../../../services/apiClient';
import { HttpResponseError } from '../../../../interfaces/IHttpResponseError';
import { IRejectCaseSameCaseModel } from '../../../../interfaces/ISameCaseModel';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useRejectCaseSameCaseMutation = () => {
    return useMutation({
        mutationFn: async (rejectModel: IRejectCaseSameCaseModel) => {
            const response = await _apiClient.rejectCaseSameCase(rejectModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to reject case');
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
    });
};
